/** The page for an address that leads nowhere (an unknown path, or a program the person is not part of): the brand bar, a plain line and a real way back. */
import { GxTopBar } from "./TopBar";
import { Link } from "./history";

export function NotFound({ backTo, title = "We couldn't find that page." }: { readonly backTo: string | null; readonly title?: string }) {
  return (
    <div className="gx-notfound-page" data-testid="shell.notfound">
      <GxTopBar bankName="Governexus" subline="" role={null} name="" clock={null} />
      <main className="gx-notfound">
        <div className="gx-eyebrow">Not found</div>
        <h1 className="gx-h1">{title}</h1>
        <p className="gx-muted">The link may be out of date, or it may belong to another program.</p>
        {backTo === null ? null : <Link href={backTo} className="gx-btn gx-btn--primary" data-testid="shell.notfound.back">Back to your bank</Link>}
      </main>
    </div>
  );
}
